import { render, staticRenderFns } from "./taxExport-table.vue?vue&type=template&id=18cfed94&"
import script from "./taxExport-table.vue?vue&type=script&lang=js&"
export * from "./taxExport-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports